import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import InlineBanner, {InlineBannerType} from 'ui-library/banners/InlineBanner';
import Col from 'ui-library/bs/Col';
import FormGroup from 'ui-library/bs/FormGroup';
import FormInput from 'ui-library/bs/FormInput';
import Label from 'ui-library/bs/Label';
import Row from 'ui-library/bs/Row';
import {ButtonStyle} from 'ui-library/buttons/Button';
import Modal from 'ui-library/modals/Modal';
import copyToClipboard from 'util/clipboard/copyToClipboard';

export function SuccessfulAPIKeyCreationModal({
  apiKey,
  expiresAt,
  onRequestClose,
}: {
  apiKey: string;
  expiresAt?: string | null;
  onRequestClose: () => void;
}): JSX.Element {
  const button = {key: 'confirm', text: 'Done', cancel: true, style: ButtonStyle.PRIMARY};
  const text = 'Make sure to save your API key now in a secure location, as it cannot be retrieved later.';
  return (
    <Modal
      title="API Key Creation Confirmation"
      onRequestClose={onRequestClose}
      closeable={true}
      buttons={[button]}
      titleIcon="done"
    >
      <Row>
        <Col md={12}>
          <FormGroup>
            <Label>API Key (click to copy)</Label>
            <FormInput
              readOnly={true}
              selectAllOnClick={true}
              value={`${apiKey}`}
              onClick={(e) => {
                copyToClipboard(apiKey, {
                  showToastOnSuccess: true,
                  toastText: 'API key copied to clipboard!',
                });
              }}
            />
            {BenchlingConfig.IDENTITY_ENABLE_API_KEY_EXPIRATION && expiresAt && (
              <div>{`Expires at: ${expiresAt}`}</div>
            )}
            <div className="u-spacing">
              <InlineBanner bannerType={InlineBannerType.WARNING} text={text} />
            </div>
          </FormGroup>
        </Col>
      </Row>
    </Modal>
  );
}

export default SuccessfulAPIKeyCreationModal;
